export default function Cross(props) {

    return (
        <div onClick={() => props.click && props.click()} className="cross">
            <div className="line"></div>
            <div className="line"></div>
        </div>
    )
}